import { infer as Infer } from 'zod';

import { userCreateSchema } from '#user/userCreate.schema';

/**
 * Data entered inline when drafting a new parent account before it is
 * created and linked to a student.
 */
export const parentDraftSchema = userCreateSchema.pick({
  name: true,
  surname: true,
  email: true,
  phone: true,
  birthdate: true,
});

export type ParentDraftSchema = Infer<typeof parentDraftSchema>;
